export default __webpack_public_path__ + "static/media/vi.6b5c07f8.svg";